var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("div", { staticClass: "print-header" }, [
      _vm.title
        ? _c(
            "div",
            {
              staticClass: "body-content",
              staticStyle: { "font-size": "20px" },
            },
            [
              _c("div", [
                _c("table", { staticStyle: { width: "100%" } }, [
                  _c("tr", [
                    _vm.schoolName
                      ? _c("td", { staticStyle: { width: "35%" } }, [
                          _vm._v(_vm._s(_vm.schoolName)),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _c("td", { staticStyle: { "text-align": "center" } }, [
                      _c(
                        "span",
                        {
                          staticStyle: {
                            "text-align": "center",
                            display: "inline-block",
                            margin: "10px 0",
                          },
                        },
                        [
                          _vm.title
                            ? _c("p", [
                                _c("b", [
                                  _vm._v(" " + _vm._s(_vm.title) + " "),
                                ]),
                              ])
                            : _vm._e(),
                        ]
                      ),
                    ]),
                    _vm._v(" "),
                    _c("td", {
                      staticStyle: { width: "35%", "text-align": "center" },
                    }),
                  ]),
                ]),
              ]),
            ]
          )
        : _vm._e(),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }